import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { messengerConversationPath } from "../../utils/messengerPaths";

function pathFromPushData(data = {}) {
  const link = data.link || data.nextPath;
  if (typeof link === "string" && link.startsWith("/")) {
    return link;
  }
  if (typeof link === "string" && link.startsWith("http")) {
    try {
      const url = new URL(link);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return null;
    }
  }

  const type = String(data.type || "").toUpperCase();
  const senderUserId = String(data.senderUserId || "").trim();
  if (type === "MESSENGER_MESSAGE" && senderUserId) {
    const role = api.getAuthRoleFromToken?.() || data.audience || "";
    return messengerConversationPath(role, senderUserId);
  }
  return null;
}

/**
 * Routes service-worker notification clicks into React Router.
 */
export default function PushNotificationNavigation() {
  const navigate = useNavigate();

  useEffect(() => {
    function openPath(path) {
      if (!path || !path.startsWith("/")) return;
      navigate(path);
    }

    function onServiceWorkerMessage(event) {
      if (event.data?.type === "NOTIFICATION_OPEN") {
        openPath(event.data.path);
      }
    }

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("message", onServiceWorkerMessage);
    }

    return () => {
      if (navigator.serviceWorker) {
        navigator.serviceWorker.removeEventListener("message", onServiceWorkerMessage);
      }
    };
  }, [navigate]);

  return null;
}
